module.exports = __webpack_public_path__ + "static/media/JMK01@m.51637689.jpg";